export function removeItem<T=any>(arr: Array<T>, predicate?: ((item: T) => boolean)| number){
  return arr.filter(typeof predicate === "number" ? (item: any) => item !== predicate : predicate as (item: T) => boolean)
}
